import { Timestamp } from 'firebase/firestore';
import { newId } from '@/lib/id';
import { toIsoSec } from '@/lib/date';

export type Shift = {
  id: string;
  userId: string | null;
  dateStarted: string | null;
  dateEnded: string | null;
  place: string | null;
  totalBilled: string | null;
  totalRawBilled: string | null;
  finalId: string | null;
  mdType: string | null;
  facturationType: string | null;
};

export const CURRENT_SHIFT_ID = 'current_shift';

export function emptyShift(): Shift {
  return {
    id: '',
    userId: null,
    dateStarted: null,
    dateEnded: null,
    place: null,
    totalBilled: null,
    totalRawBilled: null,
    finalId: null,
    mdType: null,
    facturationType: null,
  };
}

function asIsoString(v: unknown): string | null {
  if (v == null) return null;
  if (v instanceof Timestamp) return toIsoSec(v.toDate());
  if (v instanceof Date) return toIsoSec(v);
  return String(v);
}

function asString(v: unknown): string | null {
  return v == null ? null : String(v);
}

export function shiftFromDoc(id: string, data: Record<string, unknown>): Shift {
  return {
    id,
    userId: asString(data.userId),
    dateStarted: asIsoString(data.dateStarted),
    dateEnded: asIsoString(data.dateEnded),
    place: asString(data.place),
    totalBilled: asString(data.totalBilled),
    totalRawBilled: asString(data.totalRawBilled),
    finalId: asString(data.finalId) ?? id,
    mdType: asString(data.mdType),
    facturationType: asString(data.facturationType),
  };
}

export function shiftToMap(s: Shift): Record<string, unknown> {
  const { id: _id, ...fields } = s;
  return Object.fromEntries(
    Object.entries(fields).filter(([, v]) => v != null),
  );
}

export function seedShift(args: {
  userId: string;
  place: string;
  mdType: string;
  facturationType: string;
  start: Date;
  end: Date;
}): Shift {
  return {
    id: '',
    userId: args.userId,
    dateStarted: toIsoSec(args.start),
    dateEnded: toIsoSec(args.end),
    place: args.place,
    totalBilled: '0',
    totalRawBilled: '0',
    finalId: newId(),
    mdType: args.mdType,
    facturationType: args.facturationType,
  };
}
